import '@/app/app.css';
import './contacts.css';

import '@/app/app';
import '@/layouts/main/main';

import { mapComponent } from '@/features/map-component/map-component.js';

const handleLocationClick = ({ target }) => {
	const { pointId } = target.dataset;
	const map = document.querySelector('#map');
	map.scrollIntoView(false);
	window.app.mapComponent.setActive(pointId);
};

window.addEventListener('DOMContentLoaded', () => {
	mapComponent(document.querySelector('#map'), true);
	document.querySelectorAll('.contacts-item__location')
		.forEach((button) => button.addEventListener('click', handleLocationClick));
});
